import { EventEmitter } from '@djs';
import { AudioPlayerController } from './AudioPlayerController';

type VoiceMessageEvents = 'mediaChanged' | 'speedChanged';

type VoiceMessageEmitterEvents = Record<VoiceMessageEvents, VoidFunction>;

const DEFAULT_SPEED_VARIANTS = [1, 1.5, 2, 0.5];

interface MediaPlayerControllerParams {
  speedVariants?: number[];
  initialSpeedValue?: number;
}

/**
 * Класс, упорядочивающий воспроизведение нескольких медиафайлов
 */
export class MediaPlayerController {
  private readonly emitter: EventEmitter<VoiceMessageEmitterEvents> = new EventEmitter();
  on = this.emitter.on;
  off = this.emitter.off;

  private media: { id: string; type: 'audio'; commonSpeedControl: boolean; item: AudioPlayerController } | null = null;

  get activeMedia() {
    return this.media;
  }

  private speedVariants: number[];
  private speedIndex: number;

  constructor(params?: MediaPlayerControllerParams) {
    const { speedVariants = DEFAULT_SPEED_VARIANTS, initialSpeedValue = 1 } = params || {};
    this.speedVariants =
      speedVariants.indexOf(initialSpeedValue) === -1 ? [initialSpeedValue, ...speedVariants] : speedVariants;
    this.speedIndex = this.speedVariants.indexOf(initialSpeedValue);
  }

  get speed() {
    return this.speedVariants.at(this.speedIndex) ?? 1;
  }

  switchSpeed() {
    this.speedIndex = (this.speedIndex + 1) % this.speedVariants.length;
    if (this.media && this.media.commonSpeedControl) {
      this.media.item.speed = this.speed;
    }
    this.emitter.emit('speedChanged');
  }

  pause() {
    this.media?.item.pause();
  }

  setAudioMedia(mediaId: string, url: string, commonSpeedControl: boolean) {
    this.media?.item.destroy();
    const item = new AudioPlayerController(url, { autoplay: true, speed: commonSpeedControl ? this.speed : 1 });
    this.media = { id: mediaId, type: 'audio', commonSpeedControl, item };
    this.emitter.emit('mediaChanged');
  }

  resetMedia(mediaId: string) {
    if (this.media?.id === mediaId) {
      this.media.item.destroy();
      this.media = null;
      this.emitter.emit('mediaChanged');
    }
  }

  destroy() {
    this.media?.item.destroy();
    this.media = null;
    this.emitter.reset();
  }
}
